import angular from "angular";

import SubscriptionService from "./SubscriptionService";
import Assert from "tbAssert";

import ElectionDataServiceModule from "../ElectionDataService";

const mElectionDataSvc = new WeakMap();
const mQSvc = new WeakMap();
const mLogSvc = new WeakMap();

class ElectionSubscriptionService extends SubscriptionService {
    constructor($q, $log, ElectionData) {
        super();

        Assert.StrictAssert($q != null, "Assertion Failure: Missing Q Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert(ElectionData != null, "Assertion Failure: Missing Election Data Service Dependency");

        mQSvc.set(this, $q);
        mLogSvc.set(this, $log);
        mElectionDataSvc.set(this, ElectionData);
    }

    getTarget(electionTargetId) {
        let electionRetrievalPromise =
            mElectionDataSvc.get(this)
                .getCore({electionId: electionTargetId})
                .$promise
                .then(
                    (retrievedElection) => retrievedElection.result,
                    (errorResponse) => mQSvc.get(this).reject(errorResponse)
                );

        return electionRetrievalPromise;
    }

    getTargetBatch(electionTargetIds) {
        let electionRetrievalPromises = electionTargetIds.map((tgtId) => this.getTarget(tgtId));

        return mQSvc.get(this).all(electionRetrievalPromises);
    }

    addSubscription(recipientId, electionTargetId) {
        let subAddPromise = mElectionDataSvc.get(this).addSubscription({
                electionId: electionTargetId,
                recipientId: recipientId
            })
            .$promise
            .then(
                (updatedElectionResource) => {
                    let updatedElection = updatedElectionResource.result;
                    let selectedSubs = updatedElection.electionSubscribers;
                    let numSubs = selectedSubs.length;
                    let foundSubscriber = false;
                    for (let subIdx = 0; (!foundSubscriber) && (subIdx < numSubs); subIdx++) {
                        if (selectedSubs[subIdx].recipientId === recipientId) {
                            foundSubscriber = true;
                        }
                    }
                    if (!foundSubscriber) {
                        mQSvc.get(this).reject("Failed to add subscription.");
                    }
                    else {
                        return true;
                    }
                },
                (errorResponse) => {
                    return mQSvc.get(this).reject(errorResponse);
                }
            );

        return subAddPromise;
    }

    removeSubscription(recipientId, electionTargetId) {
        let subDelPromise = mElectionDataSvc.get(this).removeSubscription({
                electionId: electionTargetId,
                recipientId: recipientId
            })
            .$promise
            .then(
                (updatedElectionResource) => {
                    let updatedElection = updatedElectionResource.result;
                    let selectedSubs = updatedElection.electionSubscribers;
                    let numSubs = selectedSubs.length;
                    let foundSubscriber = false;
                    for (let subIdx = 0; (!foundSubscriber) && (subIdx < numSubs); subIdx++) {
                        if (selectedSubs[subIdx].recipientId === recipientId) {
                            foundSubscriber = true;
                        }
                    }
                    if (!foundSubscriber) {
                        return true;
                    }
                    else {
                        mQSvc.get(this).reject("Failed to remove subscription.");
                    }
                },
                (errorResponse) => {
                    return mQSvc.get(this).reject(errorResponse);
                }
            );

        return subDelPromise;
    }
}

ElectionSubscriptionService.$inject = [ "$q", "$log", "ElectionData" ];

export default angular
    .module("trackerbase-app.services.subscription-data-adapters.election-subscription-service",[
        ElectionDataServiceModule
    ])
    .service("ElectionSubscriptionData", ElectionSubscriptionService)
    .name;




//////////////////
// WEBPACK FOOTER
// ./src/services/subscription-data-services/ElectionSubscriptionService.js
// module id = wVFv
// module chunks = 1